import ChartNivDalingOsmolariteit from "../../../../src/client/niv_acuteboekje/json/daling-osmolariteit.json";
import ChartNivSchematic from "../../../../src/client/niv_acuteboekje/interactions/chart_schematic/ChartNivSchematic";
import * as React from 'react';
export default {
  ChartNivDalingOsmolariteit,
  ChartNivSchematic,
  React
};